export enum ComponentType {
  price_calculation = 'Price calculation',
  customer_rebates = 'Customer rebates',
}
